<div class="w-full">
  <form [formGroup]="createForm">
    <div class="flex flex-column gap-2">
      @if(reviewerName){
        <div>
          Candidate:  {{reviewerName}}
        </div>
      }
     @if(message){
        <div>{{message}}</div>
      }
      @if(isStartedRole){
      <div class="grid">
        <div class="lg:w-6 col-6 mt-3">
          <div class="mb-2">
            Please select a new start date for the candidate role.
          </div>
         
          <p-floatLabel class="h-full">
            <p-calendar [minDate]="minDate"
            inputId="start-date-selector" formControlName="positionStarted" placeholder="mm/dd/yyyy" [autofocus]="false" />
            <label for="start-date-selector">Start Date</label>
          </p-floatLabel>
          @if(createForm.get('positionStarted')?.hasError('required')){
            <div class="p-error">
              This is required.
            </div>
          }
        </div>
        <div class="lg:w-6 col-6 flex mt-3 align-items-center justify-content-center">
          <div class="flex flex-column align-items-start gap-2">
            <label for="time" class="text-sm font-medium block">Start Time</label>
            <p-calendar inputId="calendar-timeonly" formControlName="startTime" [timeOnly]="true" hourFormat="12"
            styleClass="slider-style" />
          </div>
        </div>
      </div>
    }
    </div>

    <div class="flex gap-4 align-items-center mt-4" [ngClass]="{'justify-content-between':isStartedRole,'justify-content-end':!isStartedRole}">

      @if(isStartedRole){
        <div class="flex gap-2">
          @if(reviewerName){
            Do you want to send an offer with this start date to {{reviewerName}} ?
          }
          @else{
            Do you want to send offers with this start date to the selected {{ selectedReviewers }} reviewer(s)?
          }
          
        </div>  
      }
      <div class="flex gap-2" [ngClass]="{'mt-4':!isStartedRole}">
        <p-button label="yes" size="large" [rounded]="true" (onClick)="closeDialog(true)"
          [ngStyle]="{'margin-right': '10px'}" styleClass="freshgreen-background" />
        <p-button label="no" size="large" [rounded]="true" (onClick)="closeDialog()" severity="danger" />
      </div>
    </div>
  </form>
</div>